<div class="ui basic segment" [class.loading]="isLoading">
    <app-steps
        #appSteps
        [labels]="{ primary: 'save' }"
        [steps]="[informationStep, documentStep, onboardingStep, reviewStep]"
        (onPrimary)="onSave()"
        (onNext)="onStepChange()"
    >
        <app-step
            #informationStep
            step="applicant-tracker.information"
            [stepForm]="informationForm"
            title="applicant-tracker.letsBringThemOnBoard"
        >
            <ui-card
                *ngIf="fromURL === 'recruiting'"
                class="banner"
                banner
                [innerHTML]="
                    { key: 'applicant-tracker.humiWillConnectThisEmployeeProfile', params: { name: employee.fullName } }
                        | appTranslate
                        | sanitizeHtml
                "
            >
            </ui-card>

            <app-employees-form-hire-information
                #informationForm
                [account]="account"
                [employee]="employee"
                [salary]="salary"
            >
            </app-employees-form-hire-information>
        </app-step>

        <app-step
            #documentStep
            step="applicant-tracker.documents"
            [stepForm]="onboardingDocumentsForm"
            title="applicant-tracker.onboardingDocuments"
        >
            <app-employees-form-hire-onboarding-documents
                #onboardingDocumentsForm
                [(documentAssignments)]="documentAssignments"
            >
            </app-employees-form-hire-onboarding-documents>
        </app-step>

        <app-step
            #onboardingStep
            step="applicant-tracker.onboarding"
            [stepForm]="onboardingForm"
            title="applicant-tracker.onboarding"
        >
            <app-employees-form-hire-onboarding
                #onboardingForm
                [(taskTemplates)]="taskTemplates"
                [(customFields)]="customFields"
                [(reminders)]="reminders"
                [(workSchedule)]="workSchedule"
                [(roles)]="roles"
                [(addToTimeTracking)]="addToTimeTracking"
                [(timeTrackingProjects)]="timeTrackingProjects"
                [(addToTimeTrackingPayrollIntegration)]="addToTimeTrackingPayrollIntegration"
                [(trainingPrograms)]="trainingPrograms"
                [(benefitPlan)]="benefitPlan"
                [(benefitDivision)]="benefitDivision"
                [(isWaitingPeriodWaved)]="isWaitingPeriodWaved"
                [(simplyBenefitsData)]="simplyBenefitsData"
                [(selectedBenefitLabel)]="selectedBenefitLabel"
                [employee]="employee"
                [(timeOffPolicies)]="timeOffPolicies"
            ></app-employees-form-hire-onboarding>
        </app-step>

        <app-step #reviewStep step="applicant-tracker.review" [stepForm]="reviewForm" title="applicant-tracker.review">
            <app-employees-form-hire-review
                #reviewForm
                [employee]="employee"
                [account]="account"
                [salary]="salary"
                [documentAssignments]="documentAssignments"
                [customFields]="customFields"
                [onboardingReminders]="reminders"
                [workSchedule]="workSchedule"
                [roles]="roles"
                [addToTimeTracking]="addToTimeTracking"
                [timeTrackingProjects]="timeTrackingProjects"
                [(addToTimeTrackingPayrollIntegration)]="addToTimeTrackingPayrollIntegration"
                [trainingPrograms]="trainingPrograms"
                [selectedBenefitLabel]="selectedBenefitLabel"
                [defaultOnboardingVideo]="options?.defaultOnboardingVideo"
                [onboardingVideo]="onboardingVideo"
                [(timeOffPolicies)]="timeOffPolicies"
            ></app-employees-form-hire-review>
        </app-step>
    </app-steps>
</div>
